import { RPC_GIFT_ENDPOINTS } from "../endpoints";
import postgreApiService from "./apiService";
import { getStoredUserId, getStoredCompanyId } from "../../utils/user";
import { isSuccess } from "./utils";

const isValidImageSource = (value) => {
    const source = String(value || "").trim();
    if (!source) return false;
    return (
        source.startsWith("http://") ||
        source.startsWith("https://") ||
        source.startsWith("/") ||
        source.startsWith("data:image/")
    );
};

const normalizeGift = (product) => {
    const rawImage = product?.Image || product?.image;
    const productPrice = product?.ProductPrice ?? product?.productPrice ?? 0;
    return {
        id: String(product?.OrderDetailId ?? product?.order_detail_id ?? ""),
        name: product?.Name || product?.name || "Unnamed gift",
        code: String(product?.Code ?? product?.code ?? ""),
        price: `€${Number(productPrice).toFixed(2)}`,
        image: isValidImageSource(rawImage) ? rawImage : null,
    };
};

export const getMyGifts = async () => {
    const LoginUserId = getStoredUserId();
    const CompanyId = getStoredCompanyId();

    const response = await postgreApiService.post(RPC_GIFT_ENDPOINTS.GET_MY_GIFTS, {
        json_data: { LoginUserId, CompanyId },
    });

    const raw = response?.data || {};
    const orders = Array.isArray(raw?.data) ? raw.data
        : Array.isArray(raw?.Data) ? raw.Data
        : Array.isArray(raw) ? raw
        : [];

    const gifts = orders.flatMap((order) => {
        const products = Array.isArray(order?.Products) ? order.Products
            : Array.isArray(order?.products) ? order.products
            : [];
        return products.map((product) => normalizeGift(product));
    });

    const total = gifts.reduce((sum, gift) => {
        return sum + Number(String(gift.price || "").replace(/[^\d.]/g, ""));
    }, 0);

    return {
        success: isSuccess(raw?.success),
        gifts,
        totalValue: `€${total.toFixed(2)}`,
    };
};
